import { NiceModalHandler } from '@ebay/nice-modal-react';
import { Button, InputBase, styled } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

import { getBonusCDK } from '@/api/bonus';
import { implog } from '@/api/implog';
import BlurryLoadingImage from '@/components/progressive-img';
import { resolveImgPath } from '@/utils/img';
import Storage from '@/utils/Storage';
import { toast } from '@/utils/toast';
import { openUrl } from '@/utils/utils';

import styles from './styles.module.less';

const CenteredInputBase = styled(InputBase)(() => ({
  textAlign: 'center',
  '& input': {
    textAlign: 'center',
    color: '#fff',
    fontSize: '0.38rem',
    lineHeight: '0.42rem'
  }
}));

const GetCDKModal = (modal: NiceModalHandler) => {
  useEffect(() => {
    implog('bonus_cdk_show');
  }, []);
  const [wrongTimes, setWrongTimes] = useState(0);
  const [cdk, setCDK] = useState('');
  const [fetching, setFetching] = useState(false);
  useEffect(() => {
    const storage_fetching = Storage.get('fetching_bonus_cdk');
    if (dayjs().isBefore(dayjs(storage_fetching))) {
      setWrongTimes(3);
    } else {
      setWrongTimes(0);
      Storage.remove('fetching_bonus_cdk');
    }
  }, []);
  return (
    <div
      style={{
        padding: '0.3rem 0rem 0rem',
        fontSize: '0.32rem',
        lineHeight: '0.6rem',
        textAlign: 'center',
        backgroundImage: `url(${resolveImgPath('modal/exchage_bg.webp')})`,
        backgroundSize: 'cover'
      }}
    >
      <div style={{ fontWeight: 'bold', fontSize: '0.42rem', lineHeight: '0.49rem' }}>Redemption Code</div>
      <div style={{ padding: '0 0.55rem', marginTop: '0.33rem' }}>
        <div
          style={{
            display: 'flex',
            borderRadius: '0.45rem',
            background: '#282E33'
          }}
        >
          <CenteredInputBase
            inputProps={{
              'aria-placeholder': 'Please enter',
              placeholder: 'Please enter',
              limit: 4
            }}
            value={cdk}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setCDK(event.target.value?.slice(0, 4)?.toLocaleUpperCase());
            }}
          />
          <Button
            sx={{
              width: '1.9rem',
              fontSize: '0.32rem',
              fontWeight: 'bold',
              flex: 'none',
              height: '0.9rem',
              borderRadius: '0 0.45rem 0.45rem 0'
            }}
            className="global_button_succes"
            variant="text"
            disabled={cdk.length < 4 || fetching}
            onClick={() => {
              implog('bonus_cdk_converter_click');
              if (wrongTimes > 2) {
                toast('Please send slower', { id: 'cannot-get-cdk' });
              }
              if (!cdk || wrongTimes > 2 || fetching) return;
              setFetching(true);
              getBonusCDK(cdk)
                .then((record: any) => {
                  const award = record?.record?.[0] || {};
                  toast(
                    <div style={{ width: '4.5rem', padding: '0.3rem', textAlign: 'center' }}>
                      <div>You received a bonus</div>
                      <div
                        style={{
                          color: '#ffd118',
                          fontSize: '0.35rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginTop: '0.2rem'
                        }}
                      >
                        $ {award?.amount}
                      </div>
                    </div>,
                    { id: 'get-bonus-cdk-success' }
                  );
                  modal?.hide();
                })
                .catch(() => {
                  setWrongTimes(val => val + 1);
                  if (wrongTimes === 2) {
                    Storage.set('fetching_bonus_cdk', dayjs().add(5, 'minute').toISOString());
                  }
                })
                .finally(() => {
                  setFetching(false);
                });
            }}
          >
            Redeem
          </Button>
        </div>
      </div>
      <div
        style={{ marginTop: '0.4rem', fontSize: '0.32rem', lineHeight: '0.38rem', fontWeight: '700', color: '#E8ECF0' }}
      >
        Access the {window?.privateConfig?.title || '7USslot'} channel
      </div>
      <div
        style={{
          marginTop: '0.14rem',
          fontSize: '0.32rem',
          lineHeight: '0.42rem',
          fontWeight: '700',
          color: '#E8ECF0'
        }}
      >
        Get Redemption Code
        <br /> Up to <span style={{ fontSize: '0.4rem', fontWeight: '700', color: '#FFD118' }}>$777</span>
      </div>

      <Button
        sx={{
          marginTop: '0.3rem',
          flex: 'none',
          width: '6rem',
          fontSize: '0.32rem',
          fontWeight: '700',
          color: '#E8ECF0',
          height: '0.7rem',
          background: 'linear-gradient(180deg, #3EB9E7, #1B82AA);',
          borderRadius: '0.9rem',
          textTransform: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
        variant="text"
        onClick={() => {
          implog('bonus_cdk_tel_click');
          openUrl(`https://t.me/${window?.privateConfig?.bot || 'US_7usslot'}`);
        }}
      >
        <BlurryLoadingImage
          src={resolveImgPath('modal/tel.webp')}
          style={{
            width: '0.45rem',
            height: '0.38rem',
            marginRight: '0.14rem'
          }}
          alt=""
        />
        JOIN
      </Button>
      <div className={styles.list}>
        <ol className="a">
          <li style={{ color: '#FFD118', fontWeight: '700' }}>Find the Redeem Codes on the Telegram channel!</li>
          <li>Enter the code to get a prize of up to $777.</li>
          <li>Each code is unique and each user can use it only once.</li>
          <li>Each user can redeem up to 10 codes per day.</li>
          <li>If the codes run out, stay tuned to the messages for more.</li>
          <li>{window?.privateConfig?.title || '7USslot'} has the final right to decide on the promotion.</li>
        </ol>
      </div>
    </div>
  );
};

export default GetCDKModal;
